import { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../config";
import { Check, AlertCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("No verification token found.");
      return;
    }
    axios.get(`${API}/customer/verify-email?token=${token}`)
      .then((res) => {
        setStatus("success");
        setMessage(res.data.message);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Verification failed. The link may have expired.");
      });
  }, [token]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center py-12 px-4" data-testid="verify-email-page">
      <div className="max-w-md w-full text-center">
        {status === "verifying" && (
          <div>
            <div className="spinner mx-auto mb-4" />
            <h1 className="text-2xl font-black">Verifying your email...</h1>
          </div>
        )}
        {status === "success" && (
          <div>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Check className="w-8 h-8 text-green-600" />
            </div>
            <h1 className="text-2xl font-black mb-2">Email Verified!</h1>
            <p className="text-gray-500 mb-6">{message}</p>
            <div className="flex gap-3 justify-center">
              <Link to="/"><Button className="btn-primary">Start Shopping</Button></Link>
              <Link to="/account"><Button className="btn-outline">My Account</Button></Link>
            </div>
          </div>
        )}
        {status === "error" && (
          <div>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="w-8 h-8 text-red-600" />
            </div>
            <h1 className="text-2xl font-black mb-2">Verification Failed</h1>
            <p className="text-gray-500 mb-6">{message}</p>
            <div className="flex gap-3 justify-center">
              <Link to="/account"><Button className="btn-primary">Go to Account</Button></Link>
              <Link to="/"><Button className="btn-outline">Home</Button></Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
